var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FsBodyText_internals;
import 'element-internals-polyfill';
import typographyStyles from '@cof/fs-typography-core/lib/typography.lit.min.js';
import { css, html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
/**
 * The web component implementation of the Financial Services body text component
 *
 * ## Installation
 *
 * ```bash
 * npm i @cof/fs-typography-wc
 * ```
 *
 * ## Usage
 *
 * To import the side-effectful registration of `<fs-body-text>` call
 *
 * ```javascript
 * import '@cof/fs-typography-wc/fs-body-text.js';
 * ```
 *
 * To import the `FsBodyText` class as either a base class or to self-register the custom element use
 *
 * ```javascript
 * import { FsBodyText } from '@cof/fs-typography-wc';
 * ```
 *
 * ## Example
 *
 * ```html
 * <fs-body-text size="large" variant="primary">Hello world</fs-body-text>
 * ```
 *
 * @element fs-body-text
 * @slot - The body-text text
 */
export class FsBodyText extends LitElement {
    constructor() {
        super();
        /** Contains APIs for working with the accessibility object model */
        _FsBodyText_internals.set(this, this.attachInternals());
        /**
         * Controls the overall styles for a piece of body text at this size
         * @attribute size
         */
        this.size = 'normal';
        /**
         * Adjust's the body text's styles based on what design decision the text
         * should communicate to the end user
         * @attribute variant
         */
        this.variant = 'primary';
        __classPrivateFieldGet(this, _FsBodyText_internals, "f").role = 'paragraph';
    }
    render() {
        return html `<span class="fs-body-text fs-text-color--${this.variant} fs-body-text--${this.size}">
      <slot></slot>
    </span>`;
    }
}
_FsBodyText_internals = new WeakMap();
FsBodyText.styles = [
    css `:host {
    display: block;
  }`,
    typographyStyles
];
/** Set the elemnent's canonical name */
FsBodyText.canonicalName = 'body-text';
__decorate([
    property({ type: String, reflect: true })
], FsBodyText.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true })
], FsBodyText.prototype, "variant", void 0);
//# sourceMappingURL=BodyText.js.map